import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'lang': localStorage.getItem('student_lang') === 'en' ? 'en' : 'vi'
  })
};

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  apiUrl: string = environment.apiUrl;
  constructor(private http: HttpClient) { }

  get(url: string, paramsObj: { [key: string]: any } = {}) {
    return this.http.get<any>(this.apiUrl + url, { ...httpOptions, params: paramsObj })
      .pipe(
        map((res) => res.data)
      );
  }

  post(url: string, bodyData: { [key: string]: any } = {}) {
    return this.http.post<any>(this.apiUrl + url, bodyData, httpOptions)
      .pipe(
        map((res) => res.data)
      );
  }

  put(url: string, bodyData: any) {
    return this.http.put<any>(this.apiUrl + url, bodyData, httpOptions)
      .pipe(
        map((res) => res.data)
      );
  }

  delete(url: string) {
    return this.http.delete<any>(this.apiUrl + url, httpOptions)
      .pipe(
        map((res) => res.data)
      );
  }

  getResponse(url: string) {
    return this.http.get<any>(this.apiUrl + url, { observe: 'response' });
  }

  getWithRetry(url: string, retryNumber: number) {
    return this.http.get<any>(this.apiUrl + url)
      .pipe(
        retry(retryNumber),
        map((res) => res.data)
      );
  }

  upload(url: string, formData: any) {
    return this.http.post(
      this.apiUrl + url,
      formData,
      {
        reportProgress: true,
        observe: 'events'
      }
    );
  }
}
